import React from "react";
import { Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ToolTip from "@commons/Componentes/ToolTip/Tooltip";
import { useConfiguracionInicial } from "../Hooks/useConfiguracionInicial";
import {
  CONFIGURACION_INICIAL_RUTA,
  esEstadoProcesoDisponible,
  obtenerPrimero,
} from "../Utils/configuracionInicial.constants";
import "../configuracionInicialRecordatorio.css";

export const ConfiguracionInicialNavbarItem = () => {
  const navigate = useNavigate();
  const {
    estadoAcceso,
    disponible,
    puedeAcceder,
    consultandoEstado,
  } = useConfiguracionInicial();
  const estado = obtenerPrimero(estadoAcceso, ["Estado", "estado"], null);

  if (consultandoEstado || !disponible || !puedeAcceder || !esEstadoProcesoDisponible(estado)) {
    return null;
  }

  return (
    <Nav.Item>
      <Nav.Link
        id="acceso-configuracion-inicial"
        className="ci-navbar-access"
        href={CONFIGURACION_INICIAL_RUTA}
        aria-label="Configuración inicial"
        onClick={(evento) => {
          evento.preventDefault();
          navigate(CONFIGURACION_INICIAL_RUTA);
        }}
      >
        <ToolTip placement="left" message="Configuración inicial">
          <svg
            className="ci-navbar-access__icon"
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 -960 960 960"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M300-360h60v-160h-60v50h-60v60h60v50Zm100-50h320v-60H400v60Zm200-110h60v-50h60v-60h-60v-50h-60v160Zm-360-50h320v-60H240v60Zm80 450v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z" />
          </svg>
        </ToolTip>
      </Nav.Link>
    </Nav.Item>
  );
};
